import { render } from "./WorkView.vue?vue&type=template&id=5cb3b1c0&scoped=true"
import script from "./WorkView.vue?vue&type=script&lang=js"
export * from "./WorkView.vue?vue&type=script&lang=js"

import "./WorkView.vue?vue&type=style&index=0&id=5cb3b1c0&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/personal-website/personal-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cb3b1c0"]])

export default __exports__